import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { Big } = Util;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import { Progress } from "antd";
import TagSystem from "@/components/Pages/Finance/_cmpt/TagSystem";
import Currency from "@/components/Pages/Finance/_cmpt/Currency";
import Apy from "components/Pages/Finance/_cmpt/Apy";
import BtnSubscribe from "components/Pages/Finance/_cmpt/BtnSubscribe";
import stylesCard from "@/components/Pages/Finance/Styles/card.module.less";
import XtFontScale from "@/components/Xt/fontScale";

export default observer(({ data, financialProducts, setFinancialProducts, className }) => {
  const t = useTranslation();
  const { finance } = useStore();
  // console.log("data====", data)

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      //可选，导航标签，系统或者状态
      tagSystem: (() => {
        if (data.noviceExclusive) return { type: "green", label: t("finance.tagBeginner") };
        if (data.systemTag) return { type: "red", label: data.systemTag };
      })(),
      ...data,
    };
    if(!convertData.currency)
      convertData.currency = "";
    return convertData;
  }, [data]);
  const btnData = useMemo(() => {
    return {
      productId: data.id,
      financialProducts: financialProducts,
      callback: setFinancialProducts,
    };
  }, [data]);
  const poolRewards = useMemo(() => {
    return Big(data.totalReward || 0)
      .times(data.rewardPercent || 0)
      .div(100)
      .toFixed(0);
  }, [data]);

  return (
    <div className={cx(styles.main, className)}>
      {!!selfData.tagSystem && <TagSystem data={selfData.tagSystem} className={styles.tagSystem} />}
      <div className={styles.title}>
        <Currency data={selfData.currency} isOnlyLogo />
        <span>{selfData.currency.toUpperCase() + " " + t("finance.pool")}</span>
      </div>
      <div className={styles.titleSub}>{t("finance.stake2Earn", [selfData.currency.toUpperCase(), selfData.interestCurrency.toUpperCase()])}</div>
      <div className={styles.apy}>
        {/*<Apy data={data} />*/}
        <XtFontScale isLoop>
          <span>{finance.getYearlyProfitLaunchPool(data)}</span>
        </XtFontScale>
        <div>{t("finance.estPoolApy")}</div>
      </div>
      <div className={styles.progress}>
        <Progress percent={((selfData.subscribed || 0) / selfData.totalQuota) * 100} showInfo={false} strokeWidth={10} />
        <div>{(selfData.subscribed || 0) + "/" + selfData.totalQuota + " " + selfData.currency.toUpperCase()}</div>
      </div>

      <div className={styles.btnCon}>
        <div>
          <span>{t("finance.poolRewards")}</span>
          <span>{poolRewards + " " + selfData.interestCurrency.toUpperCase()}</span>
        </div>
        <BtnSubscribe data={btnData} />
      </div>
    </div>
  );
});
